import React, {useState,useEffect,useReducer} from 'react';

import Pop from '../pop/pop.jsx';

import {
    teeth,
    teethInSide,
    topBorders,
    bottomBorders,
    hasGap,
    getToothIndex,
    getToothPosition,
    getBridgedTeeth,
    getPositionsWithoutBridges

} from '../common/teeth';

const toothWidth = 39;//46
const marginRight = 8;
const gap = 27;

const topPosition = 0;
const bottomPosition = 97;
const bridgeVerticalPad = 2;
const bridgeHorizontalPad = 5;

const topAll = ["top",topBorders];
const bottomAll = ["bottom",bottomBorders];


const BridgeGuides = (props)=> {

    const {
        bridgeState,
        popClicked,
        setTeethState,
        teethState,
        bridges,
        setBridges,
        alreadySetBridges,
        editable,
        addToBridge,
        activeTeeth,
        isOverDenture
    } = props;



    useEffect(() => {
        if(["position", "other-position"].includes(bridgeState.type)){
            const position = (bridgeState.position || getToothPosition(activeTeeth)) === "top"? "bottom" : "top";
            const teethToFade = teeth[position];
            fadeTeeth(teethToFade);
        }
    },[bridgeState.type])


    const toothAfterGap = (tooth)=>{
        return tooth+1 > teethInSide;
    }

    const createGuide = (position,teeth,key,pop,alreadySet,cannotAdd)=>{

        if(!Array.isArray(teeth))return
        const teethIndices = teeth.map(tooth=>getToothIndex(position,tooth));
        const [startIndex,endIndex] = [Math.min(...teethIndices),Math.max(...teethIndices) ];
        const addGap = hasGap(startIndex,endIndex)? gap : 0;
        const top = (position === "top"? topPosition : bottomPosition) - bridgeHorizontalPad;
        const left = (startIndex * toothWidth) + (startIndex * marginRight) + (toothAfterGap(startIndex)? gap : 0) - bridgeVerticalPad;
        const teethInBridge = endIndex - startIndex + 1;
        const width = (teethInBridge * toothWidth) + ((teethInBridge - 1) * marginRight) + addGap + (bridgeVerticalPad * 2);
        return(
                <div
                    key={key}
                    className={`bridge-guide ${isOverDenture || cannotAdd? "orange" : "pink"}`}
                    style={{
                        top, left, width
                    }}
                >
                    {pop &&
                    <Pop
                        popType={pop}
                        popClicked={popClicked}
                        teethState={teethState}
                        activeTeeth={activeTeeth}
                        getPositionsWithoutBridges={()=>getPositionsWithoutBridges(alreadySetBridges)}
                    />
                    }
                    {alreadySet && editable &&
                        <>
                            {!cannotAdd && ["left","right"].map(side=>
                                <a
                                    className={`add-to ${side}`}
                                    onClick={()=>{
                                        addToBridge(key)
                                    }}
                                >
                                    <span>{abraStr.addTeethToBridge}</span>
                                </a>
                            )}

                        <a
                        className='delete'
                        onClick={()=>{
                        setTeethState(prevState=>{
                            const newState = [...prevState];
                            let teethInBridge = [];
                            alreadySetBridges[key].teeth.map(teeth=>teethInBridge = [...teethInBridge, ...teeth]);
                            teethInBridge = getBridgedTeeth(teethInBridge,true);
                            teethInBridge.forEach(bridgeTooth=>{
                                const toothIndex = newState.findIndex(tooth=>tooth.id === bridgeTooth);
                                if(["crown","implant","abutment"].includes(newState[toothIndex].state)) {
                                    newState[toothIndex].state = "healthy";
                                    newState[toothIndex].material = "";
                                    newState[toothIndex].inSetBridge = false;
                                }
                            })
                            return newState;
                        });
                        setBridges(prevState=>{
                            const newState = [...prevState];
                            newState.splice(key,1);
                            return newState;
                        });
                    }}
                        />
                        </>
                    }
                </div>
            )
    }

    const fadeTeeth = (teethToFade)=>{
        setTeethState(prevState=>{
            const newState = [...prevState];
            prevState.forEach((item,index)=>{
                if(teethToFade.includes(item.id)) newState[index].faded = true;
            });
            return newState;
        });
    }

    const getBridgeGuides = (bridges)=>{

            if(bridges === "init" || bridges.type === "init" || bridges.bridgeSet === "init"){
                const bridgesInit = [
                    topAll,
                    bottomAll
                ]
                const addPop = bridges.progress;
                return bridgesInit.map((bridge,index)=>createGuide(...bridge,"init"+index,((addPop && index === 0)? addPop : null)));
            }else  if(bridges === "other"  || bridges.type === "other-position"  || bridges.type === "this-position"){
                const bridgesToShow = [];
                const allBridgedTeeth = [];
                for(const bridge of alreadySetBridges){

                    bridge.teeth.map(bridgedTeeth=>allBridgedTeeth.push(...getBridgedTeeth(bridgedTeeth,true)));
                }
                const hasBridgeOnTop = teeth.top.some(item=>allBridgedTeeth.includes(item));
                const hasBridgeOnBottom = teeth.bottom.some(item=>allBridgedTeeth.includes(item));
                //MAKE BRIDGES
                let bridgeBuild = [];
                let avoidOppositePosition = ["other-position", "this-position"].includes(bridges.type) && getToothPosition(bridges.activeTeeth);
                const bridgePosition = getToothPosition(bridges.activeTeeth);
                for(const position in teeth){
                    for(const tooth of teeth[position]){
                        if( bridges.type === "other-position" && position !== bridgePosition) continue;
                        if( bridges.type === "this-position" && position !== bridgePosition) continue;
                        if(
                            position === "top" && !hasBridgeOnTop ||
                            position === "bottom" && !hasBridgeOnBottom
                        )  break;
                        if(!allBridgedTeeth.includes(tooth)) {
                            if(!bridgeBuild.length)bridgeBuild.push(tooth);
                            else bridgeBuild[1] = tooth;
                            if( tooth === teeth[position][teeth[position].length-1]){
                                if(bridgeBuild.length > 1) bridgesToShow.push([position,bridgeBuild]);
                                bridgeBuild = [];
                            }
                        }else{
                            if(bridgeBuild.length > 1){
                                bridgesToShow.push([position,bridgeBuild])
                            }
                            bridgeBuild = [];
                        }
                    }
                }
                if(!hasBridgeOnTop && avoidOppositePosition !== "bottom")bridgesToShow.push(topAll);
                if(!hasBridgeOnBottom && avoidOppositePosition !== "top")bridgesToShow.push(bottomAll);
                return bridgesToShow.map((bridge,index)=>createGuide(...bridge,"other"+index));


            }else{
                switch (bridges.type) {
                    case "position":
                    const position = bridges.position || getToothPosition(bridges.teeth);
                    const bridge = position === "top"? topAll : bottomAll;
                    return createGuide(...bridge,0,bridges.progress);
                    case "process":
                        return bridges.teeth.map((item,index)=>{
                            const position = getToothPosition(item[0]);
                            const pop = bridges.status && 'add-or-complete';
                            return createGuide(position,item,index,pop);
                        });
                    case "set":
                        return bridges.bridges.map((bridge,index)=>{
                            let {teeth} = bridge;
                            //teeth = teeth[0];
                            const position = getToothPosition(teeth[0][0]);
                            return teeth.map((bridgeTeeth,index)=>createGuide(position,bridgeTeeth,index,null,!index && !bridge.bridgeProcess,bridge.bridgeType === "overDenture"));
                        });
                }
            }
    }


    return(
      <>
          {getBridgeGuides(bridgeState)}
      </>
    );

}

export default BridgeGuides;